import template from './educationQualifications.html';
import controller from './educationQualificationsCtrl';
import './style.scss';

export default {
  template,
  controller,
  controllerAs: 'vm',
};
